import { AppShell } from "@chef/feature-app-shell";
import { Card } from "@chef/components";
import { ConsentOptions } from "@chef/smart-components";
import { BRAND_PATHS } from "@chef/constants";

import { MyAccountLayout } from "../../components/MyAccountLayout";

import { intl } from "./MyAccountChangeConsentsPage.Intl";

export const MyAccountChangeConsentsPage = () => {
  return (
    <AppShell title={intl.CONSENTS}>
      <AppShell.Meta />
      <AppShell.Header />

      <AppShell.Main grid>
        <MyAccountLayout page="accountInformation">
          <section className="col-span-5 space-y-6">
            <Card id="min-konto-rediger-personalia-card-grid">
              <ConsentOptions
                exitPath={BRAND_PATHS.PERSONAL_INFORMATION_PAGE}
              />
            </Card>
          </section>
        </MyAccountLayout>
      </AppShell.Main>

      <AppShell.Footer minified />
      <AppShell.TabBar />
    </AppShell>
  );
};
